<template>
  <v-flex xs12>
    <v-layout row wrap>
      <v-flex xs12>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <v-label for="idiomas" class="mt-3" :class="errorMessages ? 'error--text' : ''" v-html="htmlLabelIdiomas"></v-label>        
        <v-input v-if="errorMessages" class="mt-0" :error-messages="errorMessages" />
      </v-flex>
      <v-flex v-if="talento.idiomas && talento.idiomas != ''" xs12 class="d-flex align-center'">
        <v-chip-group v-model="idiomas.selection" column active-class="primary--text">
          <!-- eslint-disable-next-line vue/no-mutating-props -->
          <draggable v-model="talento.idiomas" @start="dragStart" @end="dragEnd">
            <v-chip v-for="(item, index) in talento.idiomas" :key="index" small close value draggable @click:close="remove(item)"> {{ item.idioma }} ({{ item.nivel }}) </v-chip>
          </draggable>
        </v-chip-group>
      </v-flex>
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs5>
            <v-autocomplete
              v-model.trim="$v.idiomas.idioma.$model"
              :search-input.sync="searchIdioma"
              :label="$t('view.talento.form.idiomas.th')"
              :error-messages="getFirstErrorDescription($v.idiomas.idioma)"
              :items="view.elem.select.idiomas.filteredList"
              :disabled="disabled"
              prepend-inner-icon="mdi mdi-flag-variant"
              item-value="code"
              item-text="name"
              return-object
              clearable
              outlined
              filled
              dense
              :no-data-text="$t('view.commons.nodata')"
              @input="view.elem.select.idiomas.search = ''" 
              @change="add" />
          </v-flex>
          <v-flex xs5>
            <v-autocomplete
              :key="autocompleteKey"
              v-model.trim="$v.idiomas.nivel.$model"
              :label="$t('view.talento.form.nivelIdioma.label')"
              :error-messages="getFirstErrorDescription($v.idiomas.nivel)"
              :items="view.elem.select.nivelIdioma.filteredList"
              :disabled="disabled"
              item-value="code"
              item-text="name"
              clearable
              outlined
              filled
              dense
              :no-data-text="$t('view.commons.nodata')"
              @input="search = ''" 
              @change="add" />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-flex>
</template>
<script>
import CombosAPI from "@/services/catalogos"; /** *******************************/
import Draggable from "vuedraggable";
import { required } from "vuelidate/lib/validators";
import { allValidatorMethods } from "@/helpers/vuelidate";
import { TLT_NIVEL_IDIOMA_SELECT } from "@/constants/operativos";

const select = {
  idiomas: {
    completeList: []
    , filteredList: []
    , disabled: false
    , search: ""
  }
  , nivelIdioma: {
    filteredList: TLT_NIVEL_IDIOMA_SELECT
    , disabled: false
  }
};

export default {
  name: "TalentoIdiomas"
  , components: { Draggable }
  , props: {
    talento: {
      default: undefined
      , type: Object
    }
    , disabled: {
      default: false
      , type: Boolean
    }
    , errorMessages: {
      default: undefined
      , type: String
    }
  }
  , data() {
    return {
      init: true
      , autocompleteKey: 0
      , idiomas: {
        selection: null
        , current: null
        , idioma: ""
        , nivel: ""
      }
      , view: { elem: { select } }
    };
  }
  , computed: {
    searchIdioma: {
      set(val) {
        this.view.elem.select.idiomas.search = val ? val.trim() : "";
      }
      , get() {
        return this.view.elem.select.idiomas.search.trim();
      }
    }
    , htmlLabelIdiomas(){
      return this.$t("view.talento.form.idiomas.label");
    }
  }
  , async created() {
    this.$v.idiomas.$reset();
    if (this.init) {
      const { data: { results: { combo: idiomasList } } } = await CombosAPI.get({ option: "idioma" });
      this.view.elem.select.idiomas.filteredList = idiomasList ? idiomasList.filter((value) => value.status) : [];
      this.view.elem.select.idiomas.completeList = idiomasList || [];
    }
  }
  , methods: {
    ...allValidatorMethods
    , add() {
      if (this.isAllValid(this.$v.idiomas)) {
        if (this.idiomas.idioma != "" && this.idiomas.nivel != ""){
        // eslint-disable-next-line vue/no-mutating-props
          this.talento.idiomas.push({
            code: this.idiomas.idioma.code
            , name: this.idiomas.idioma.name + "(" + this.idiomas.nivel + ")"
            , idioma: this.idiomas.idioma.name
            , nivel: this.idiomas.nivel
          });
          this.view.elem.select.idiomas.filteredList = this.view.elem.select.idiomas.filteredList.filter((value) => value.code != this.idiomas.idioma.code);
          this.idiomas.idioma = "";
          this.idiomas.nivel = "";
          this.autocompleteKey++;
          this.$v.idiomas.$reset();
        }
      }
    }
    , remove(item) {
      // eslint-disable-next-line vue/no-mutating-props
      this.talento.idiomas = this.talento.idiomas.filter((value) => value.idioma != item.idioma);
      if (this.view.elem.select.idiomas.completeList.find((value) => value.code == item.code && value.status)) {
        this.view.elem.select.idiomas.filteredList.push(this.view.elem.select.idiomas.completeList.find((value) => value.code == item.code));
      }
      this.idiomas.idioma = "";
      this.idiomas.nivel = "";
      this.$v.idiomas.$reset();
    }
    , dragStart() {
      if (this.talento.idiomas[this.idiomas.selection]) this.idiomas.current = this.talento.idiomas[this.selection].idioma;
      else this.idiomas.current = null;
    }
    , dragEnd() {
      let that = this;
      if (this.idiomas.current) {
        this.talento.idiomas.forEach((x, i) => {
          if (x.name === that.idiomas.current) that.idiomas.selection = i;
        });
      }
    }
    , async loadSelectsData(idiomas = this.talento.idiomas) {
      let idiomasarr = idiomas.map((item) => item.code);
      this.view.elem.select.idiomas.filteredList = idiomas
        ? this.view.elem.select.idiomas.completeList.filter((value) => !idiomasarr.includes(value.code) && value.status)
        : this.view.elem.select.idiomas.completeList;
    }
  }
  , validations: {
    idiomas: {
      idioma: { required }
      , nivel: { required }
    }
  }
};
</script>

<style scoped>
.talento .idiomas.v-size--x-small {
  width: 25px;
  height: 25px;
}
</style>



// WEBPACK FOOTER //
// src/views/talento/TalentoIdiomas.vue